import React from 'react'
import {Icon} from '@chakra-ui/react'

const CloseIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" cursor="pointer" fill="transparent" {...props}>
            <path
                d="M31.8277 32.8675C31.5777 32.8675 31.3178 32.7675 31.1178 32.5776L8.29244 9.88215C7.90252 9.49223 7.90252 8.86236 8.29244 8.47243C8.68236 8.08251 9.31224 8.08251 9.70216 8.47243L32.5276 31.1679C32.9175 31.5578 32.9175 32.1877 32.5276 32.5776C32.3276 32.7775 32.0776 32.8675 31.8177 32.8675H31.8277Z"
                fill="currentColor"
            />
            <path
                d="M9.01206 32.7775C8.75212 32.7775 8.50217 32.6775 8.30221 32.4876C7.91229 32.0976 7.91229 31.4678 8.30221 31.0779L31.1076 8.29244C31.4975 7.90252 32.1274 7.90252 32.5273 8.29244C32.9172 8.68236 32.9172 9.31224 32.5273 9.70216L9.72192 32.4776C9.52196 32.6675 9.27201 32.7675 9.01206 32.7675V32.7775Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default CloseIcon
